import { WORK_SAMPLES, type WorkSample } from "@/data/testimonials";

interface WorkGalleryProps {
  samples?: WorkSample[];
}

/**
 * Galería de trabajos reales con la marca del cliente. Exige más de una
 * muestra: con una sola imagen no aporta prueba y no se muestra.
 */
export const WorkGallery = ({ samples = WORK_SAMPLES }: WorkGalleryProps) => {
  if (samples.length < 2) return null;

  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14 md:mb-16">
          <span className="text-primary-dark font-medium tracking-widest uppercase text-sm">
            Trabajos reales
          </span>
          <h2 className="font-playfair font-semibold text-3xl sm:text-4xl md:text-5xl mt-3 text-brown">
            Proyectos con la marca de nuestros clientes
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {samples.map((s) => (
            <figure
              key={s.id}
              className="rounded-2xl overflow-hidden border border-primary/15 bg-background"
            >
              <img
                src={s.image}
                alt={s.alt}
                loading="lazy"
                className="w-full h-64 object-cover"
              />
              <figcaption className="p-4 text-sm text-brown-light/90">
                {s.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
